/* User Action Type */
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";

/* Channels Action Type */
export const SET_CURRENT_CHANNEL = "SET_CURRENT_CHANNEL";
export const SET_PRIVATE_CHANNEL = "SET_PRIVATE_CHANNEL";
export const SET_TOP_POSTERS = "SET_TOP_POSTERS";